var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadSuccessfull(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check 1",
    clipPath: "url(#clip0_997_59704)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M109.731 109.746C133.891 85.5856 133.891 46.4144 109.731 22.2544C85.5714 -1.90567 46.4002 -1.90567 22.2402 22.2544C-1.91985 46.4144 -1.91985 85.5856 22.2402 109.746C46.4002 133.906 85.5714 133.906 109.731 109.746Z",
    fill: "#41EAD4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.488 77.5808L91.5886 43.4802C92.0647 42.9894 92.6336 42.5982 93.2623 42.3294C93.8909 42.0605 94.5668 41.9194 95.2505 41.9142C95.9342 41.909 96.6121 42.0398 97.2448 42.2991C97.8774 42.5583 98.4522 42.9408 98.9357 43.4243C99.4192 43.9078 99.8017 44.4826 100.061 45.1152C100.32 45.7479 100.451 46.4258 100.446 47.1095C100.441 47.7932 100.299 48.4691 100.031 49.0977C99.7618 49.7264 99.3706 50.2953 98.8798 50.7714L61.1335 88.5174C60.1666 89.4841 58.8553 90.0271 57.488 90.0271C56.1208 90.0271 54.8095 89.4841 53.8426 88.5174L33.1201 67.7952C32.1774 66.8234 31.6548 65.5198 31.6651 64.1659C31.6754 62.812 32.2178 61.5165 33.1751 60.5591C34.1325 59.6017 35.4281 59.0593 36.782 59.049C38.1359 59.0387 39.4395 59.5613 40.4113 60.504L57.488 77.5808Z",
    fill: "#F8FEFD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_997_59704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 132,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadSuccessfull);
export default __webpack_public_path__ + "static/media/UploadSuccessfull.281baca58f3d335e95c0108533931072.svg";
export { ForwardRef as ReactComponent };